import { render, staticRenderFns } from "./HorasTerm.vue?vue&type=template&id=b595e538"
import script from "./HorasTerm.vue?vue&type=script&lang=js"
export * from "./HorasTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports